import { useDesignSystem } from '../../context/DesignSystemContext';
import './tag.scss';

export default function Tag({
  label,
  icon,
  iconPosition = 'left', // 'left' | 'right'
  iconStroke,
  iconFill,
  active = false,
  disabled = false,
  size = 'md', // 'sm' | 'md'
  className = '',
  onClick,
  color = 'primary',
  ...rest
}) {
  const DesignSystemComponents = useDesignSystem();
  const SvgIcon = DesignSystemComponents?.SvgIcon;
  const isClickable = !!onClick && !disabled;

  return (
    <button
      type='button'
      className={[
        'ds-tag',
        `ds-tag--${size}`,
        `ds-tag--color-${color}`,
        active ? 'ds-tag--active' : '',
        disabled ? 'ds-tag--disabled' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={isClickable ? onClick : undefined}
      disabled={disabled}
      {...rest}
    >
      {SvgIcon && icon && iconPosition === 'left' && (
        <SvgIcon
          name={icon}
          size='14px'
          className='ds-tag__icon'
          stroke={iconStroke}
          fill={iconFill}
        />
      )}

      <span className='ds-tag__label mini'>{label}</span>

      {SvgIcon && icon && iconPosition === 'right' && (
        <SvgIcon
          name={icon}
          size='14px'
          className='ds-tag__icon'
          stroke={iconStroke}
          fill={iconFill}
        />
      )}
    </button>
  );
}
